import {
	createApp
} from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vant from 'vant';
import 'vant/lib/index.css';
import {
	Lazyload
} from 'vant';
import moment from 'moment';
import 'lib-flexible/flexible';
// import 'cropperjs/dist/cropper.css';
import './utils/style.less';
// import i18n from './i18n';
import VueI18n from './i18n';
// import animate from 'animate.css'
import 'animate.css';
createApp(App)
	.use(store)
	.use(router)
	.use(Lazyload)
	.use(moment)
	.use(vant)
	.use(VueI18n)
	.use({ // 处理animate插件
		install(app) {
			app.directive('animate', {})
		}
	})
	.mount('#app');